<template>
  <div>
    <div v-if="!isMobile" class="ceMetaIndustryChat">
      <div class="industryFormPanel">
        <div class="ceMetaIndustryChatHeader">
          <div class="headerWords">产品信息输入</div>
          <div class="chatSplitLine"></div>
        </div>
        <div style="max-height: 634px; overflow: auto; padding: 0 24px">
          <div class="XHForm">
            <div class="XHFormLabel">所属行业 *</div>
            <div class="XHFormItem">
              <div class="flexPanel">
                <el-select :disabled="!!generating" v-model="product.industryType" placeholder="请选择产品行业"
                  style="width: 49%" @change="product.subIndustryType = ''; isShow = false">
                  <el-option v-for="item in IndustryList" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
                <div class="chatSplit" style="width: 2%"></div>
                <el-select :disabled="!!generating" v-model="product.subIndustryType" @change="isSonXa"
                  placeholder="请选择具体品类" style="width: 49%">
                  <el-option v-for="item in subIndustryList[product.industryType]" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </div>
            </div>
          </div>

          <div class="XHForm">
            <div class="XHFormLabel">产品名称 <span :class="isShow ? 'xDisplay' : ''">*</span></div>
            <div class="XHFormItem">
              <el-autocomplete style="width: 100%" :disabled="!!generating" clearable v-model="productName"
                :fetch-suggestions="productQuerySearch" placeholder="请输入产品名称或下拉选择已保存的产品信息" @select="productNameSelect" />
            </div>
          </div>

          <div class="XHForm">
            <div class="XHFormLabel">目标人群 <span :class="isShow ? 'xDisplay' : ''">*</span></div>
            <div class="XHFormItem">
              <el-select :disabled="!!generating" style="display: block" v-model="targetAudience" multiple filterable
                allow-create default-first-option placeholder="请输入/多选/单选目标人群">
                <el-option v-for="item in targetAudienceList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="XHForm" style="height: auto; margin-bottom: 16px">
            <div class="XHFormLabel">产品卖点 <span :class="isShow ? 'xDisplay' : ''">*</span></div>
            <div class="XHFormItem" style="height: auto">
              <el-input :disabled="!!generating" v-model="product.sellingPoint" type="textarea" :rows="3"
                placeholder="请输入内容"></el-input>
            </div>
          </div>
          <div class="flexEndPanel">
            <el-button v-show="productList.length > 0" :disabled="!!generating" type="primary" size="small"
              style="margin-bottom: 1rem; border-radius: 0.5rem" @click="dialogVisible = true">管理产品信息</el-button>
            <el-button :disabled="!!generating ||
              !product.industryType ||
              !product.subIndustryType ||
              !productName ||
              targetAudience.length === 0 ||
              !product.sellingPoint
              " type="primary" size="small" style="margin-bottom: 1rem; border-radius: 0.5rem"
              @click="savedProduct">一键保存产品信息</el-button>
          </div>
          <div class="XHForm">
            <div class="XHFormLabel">文案类型</div>
            <div class="XHFormItem">
              <el-select :disabled="!!generating" style="display: block" v-model="copywritingType" filterable allow-create
                default-first-option placeholder="请选择文案类型">
                <el-option v-for="item in copywritingTypeList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="XHForm">
            <div class="XHFormLabel">文案风格</div>
            <div class="XHFormItem">
              <el-select :disabled="!!generating" style="display: block" v-model="copywritingStyle" filterable
                allow-create default-first-option placeholder="请选择文案风格">
                <el-option v-for="item in copywritingStyleList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="XHForm">
            <div class="XHFormLabel">关键词</div>
            <div class="XHFormItem">
              <el-input :disabled="!!generating" v-model="keyWords" placeholder="请输入文案想要包含的关键词，以逗号分隔" style="width: 100%"
                default-first-option :automatic-dropdown="false" filterable multiple allow-create />
            </div>
          </div>
          <div class="XHForm">
            <div class="XHFormLabel"></div>
            <div class="XHFormItem">
              <div class="industryFormBottomBtn">
                <div class="selector">
                  生成
                  <div class="chattoolsItemStyle generatorSelect" style="width: 90px">
                    <el-select :disabled="!!generating" style="background-color: aliceblue" v-model="generatorNum">
                      <el-option v-for="n in 3" :key="n" :label="n + ' 篇'" :value="n">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="chattoolsItemStyle generatorSelect" style="width: 90px">
                    <el-select style="background-color: aliceblue" v-model="long">
                      <el-option v-for="n in [
                        { label: '短文案', value: '短' },
                        { label: '长文案', value: '长' },
                      ]" :key="n.label" :label="n.label" :value="n.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>

                <div class="chattoolsItemStyle buttonWrapper">
                  <el-button :disabled="!!generating" @click="generatorArticle" style="
                      border-radius: 1rem;
                      height: 2.5rem;
                      background-color: rgb(82, 106, 238);
                      color: #ffffff;
                    ">
                    生成文案
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="industryChatPanel el-loading-mask" v-if="loading" style="
          margin-left: calc(50% + 26px);
          top: 76px;
          width: calc(50% - 52px);
          height: 520px;
        ">
        <div style="
            position: absolute;
            width: 60px;
            height: 70px;
            top: calc(50% - 37px);
            left: calc(50% - 30px);
          ">
          <img src="../../assets/statics/load.gif" style="width: 60px; height: 60px" />
          <span style="
              font-size: 14px;
              height: 20px;
              line-height: 20px;
              display: block;
              width: 60px;
              text-align: center;
            ">生成中..</span>
        </div>
      </div>
      <div class="industryChatPanel">
        <div class="ceMetaIndustryChatHeader" style="padding: 0">
          <div class="headerWords">小红书文案生成</div>
          <div class="chatSplitLine"></div>
        </div>
        <div class="chatBodyPanel" id="contentEle">
          <div class="industryChatContentPanel" :key="index" v-for="(item, index) in copywritingList">
            <!-- 打星 保存 -->
            <div class="industryHeadTools" v-if="!generating && !item.editStatus">
              <div style="align-items: center; justify-content: center">
                <el-rate v-model="item.star" @change="setArticleStar(index)"></el-rate>
              </div>
              <span style="font-size: 14px">{{
                "字数：" + item.contentWords.length
              }}</span>
            </div>

            <div style="padding: 3px 14px; font-size: 16px">
              No.{{ index + 1 }}
            </div>
            <div v-if="item.editStatus === true" class="industryChatContent"
              style="padding-top: 24px; padding-bottom: 24px">
              <el-input :disabled="!!generating" type="textarea" v-model="item.editContentWords" autosize />
            </div>
            <div v-else class="industryChatContent" @click="editArticleContent(index)">
              {{ item.contentWords }}
            </div>

            <div class="chatSplitLine"></div>
            <div class="industryChatTools">
              <div class="chattoolsItemStyle">
                <!-- <el-button
                v-show="!generating && !item.editStatus"
                type="text"
                @click="exportAsWord(index)"
                >导出为word</el-button
              > -->
                <el-button v-show="!generating && !item.editStatus" class="copy_btn" type="text"
                  @click="copyContent(index)" :data-clipboard-text="item.contentWords">一键复制</el-button>
                <el-button v-show="item.editStatus" type="text" @click="finishEditArticleContent(index)">结束编辑</el-button>
                <el-button v-show="item.editStatus &&
                  item.contentWords !== item.editContentWords
                  " type="text" @click="revertArticleContent(index)">还原文案</el-button>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top: 17px">
          <el-button v-if="!!generating" @click="stopGeneratArticle" style="
              border-radius: 1rem;
              height: 2.5rem;
              background-color: rgb(82, 106, 238);
              margin-left: 2rem;
              width: 7rem;
              color: #ffffff;
              float: right;
            ">
            停止生成
          </el-button>
        </div>
        <ServiceModal />
      </div>

      <el-dialog title="提示" :visible.sync="dialogVisible" width="50%">
        <el-table :data="productList" height="450" style="width: 100%">
          <el-table-column prop="productName" label="产品名称" />
          <el-table-column label="目标人群">
            <template slot-scope="scope">
              <span>{{ scope.row.targetAudience.join(",") }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="sellingPoint" label="产品卖点">
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button size="mini" type="danger"
                @click="askDeleteProduct(scope.row.id, scope.row.productName)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <ServiceButton />
      <ChangeWordsEntry :visible="changeWordsDialogVisible" :close="close" />
    </div>
    <div v-else class="mobileLayout">
      <div class="logo">
        <div>CeMeta AI</div>
        <div>让营销更容易</div>
      </div>
      <div class="title">小红书营销文案助手</div>
      <el-button type="primary" @click="gotoMobileIndex" class="button">
        立即体验
      </el-button>
      <ChangeWordsEntry :visible="changeWordsDialogVisible" :close="close" />
    </div>
  </div>
</template>

<script>
import Api from "../../http/api";
import Clipboard from "clipboard";
import ServiceModal from "./ServiceModal.vue";
import ServiceButton from "../login/ServicesButton.vue";
import ChangeWordsEntry from "./ChangeWordsEntry.vue";

export default {
  components: { ServiceModal, ServiceButton, ChangeWordsEntry },
  methods: {
    isSonXa(e) {
      console.log(e)
      if (e === '松下洗碗机') {
        this.isShow = true
      } else {
        this.isShow = false

      }
    },
    gotoMobileIndex() {
      window.location.href = "/mobileChat";
    },
    async getProductList() {
      const res = await Api.Product.getProductList({
        type: "xiaohongshu-article",
      });

      if (res.data) {
        this.productList = res.data.map((a) => {
          return {
            id: a._id,
            value: a.data.productName,
            label: a.data.productName,
            industryType: a.data.industry,
            subIndustryType: a.data.subIndustry,
            targetAudience: a.data.targetAudience.split(","),
            productName: a.data.productName,
            sellingPoint: a.data.sellingPoint,
          };
        });
      }
    },
    async setArticleStar(index) {
      if (!this.userName) {
        return this.$message.error("未登录");
      }
      const res = await Api.Chat.setArticleStar({
        article: btoa(encodeURI(this.copywritingList[index].contentWords)),
        type: "xiaohongshu-article",
        star: this.copywritingList[index].star,
        title: this.productName,
        id: this.copywritingList[index].id,
      });

      if (res.error) {
        return this.$message.error("评分失败");
      }

      this.copywritingList[index].id = res.data.id;
      this.$message.success("评分成功");
    },
    async savedProduct() {
      if (!this.userName) {
        return this.$message.error("未登录");
      }
      let res = await Api.Product.saveProduct({
        type: "xiaohongshu-article",
        params: {
          industry: this.product.industryType,
          subIndustry: this.product.subIndustryType,
          productName: this.productName,
          targetAudience: this.targetAudience.join(","),
          sellingPoint: this.product.sellingPoint,
          userId: this.userId,
        },
      });
      if (res.error) {
        return this.$message.error(res.error.message);
      }
      this.getProductList();
      return this.$message.success("保存成功");
    },
    editArticleContent(index) {
      if (!this.updateArticleTimer && !this.generating) {
        this.copywritingList[index].editContentWords =
          this.copywritingList[index].contentWords;
        this.copywritingList[index].editStatus = true;
      }
    },
    revertArticleContent(index) {
      this.copywritingList[index].editContentWords =
        this.copywritingList[index].contentWords;
    },
    finishEditArticleContent(index) {
      this.copywritingList[index].contentWords =
        this.copywritingList[index].editContentWords;
      this.copywritingList[index].editContentWords = "";
      this.copywritingList[index].editStatus = false;
    },
    async generatorArticle() {
      try {
        if (this.count < 200) {
          this.changeWordsDialogVisible = true;
          return;
        }
        if (!this.userName) {
          return this.$message.error("未登录");
        }

        if (!this.product.industryType) {
          return this.$message.error("产品行业不能为空");
        }
        if (!this.product.subIndustryType) {
          return this.$message.error("产品具体品类不能为空");
        }

        if (this.show) {
          if (!this.productName) {
            return this.$message.error("产品名称不能为空");
          }
          if (this.targetAudience.length === 0) {
            return this.$message.error("目标人群不能为空");
          }
          if (!this.product.sellingPoint) {
            return this.$message.error("产品卖点不能为空");
          }

        }

        if (this.generating === false) {
          this.loading = true;
        }

        _baq.track("game_addiction", { assets_id: "1772924118818887" });
        this.generating = true;
        const params = {
          payload: {
            productName: this.productName,
            targetAudience: this.targetAudience,
            articleType: this.copywritingType,
            articleStyle: this.copywritingStyle,
            sellingPoint: this.product.sellingPoint,
            keyWords: this.keyWords
              ? this.keyWords.includes("，")
                ? this.keyWords.split("，")
                : this.keyWords.split(",")
              : [],
            industry: this.product.subIndustryType,
            long: this.long,
          },
          type: "xiaohongshu_article_assistant",
        };

        let res = await Api.Chat.askForAI(params);

        if (res.data) {
          let res1 = await Api.Chat.getAnswerForAsk(res.data.id);
          let answer = res1.data;

          this.copywritingList.push({
            contentWords: answer.content,
            editContentWords: "",
            editStatus: false,
            isCopy: false,
            star: 0,
            articleId: res.data.id,
          });

          if (!answer.isFinish) {
            this.updateArticleTimer = setInterval(async () => {
              let res2 = await Api.Chat.getAnswerForAsk(res.data.id);

              if (res2.data) {
                if (
                  res2.data.content !== "" &&
                  this.copywritingList[this.copywritingList.length - 1]
                    .contentWords !== res2.data.content
                ) {
                  this.copywritingList[
                    this.copywritingList.length - 1
                  ].contentWords = res2.data.content;
                  this.loading = false;
                }

                if (res2.data.isFinish) {
                  clearInterval(this.updateArticleTimer);
                  this.updateArticleTimer = null;
                  await Api.Chat.saveCount({
                    type: "xiaohongshu_article_assistant",
                    id: res.data.id,
                    count: res2.data.content.length,
                  });

                  this.$store.dispatch("setCount");
                  this.copywritingList[
                    this.copywritingList.length - 1
                  ].editStatus = false;
                  this.copywritingList[
                    this.copywritingList.length - 1
                  ].isCopy = false;

                  if (this.copywritingList.length < this.generatorNum) {
                    this.generatorArticle();
                  } else {
                    this.generating = false;
                  }
                }
                document
                  .getElementById("contentEle")
                  .scrollTo(
                    0,
                    document.getElementById("contentEle").scrollHeight
                  );
              }
            }, 600);
          }
        } else {
          this.loading = false;
          this.generating = false;
          if (res.error.message === "Insufficient balance, please recharge") {
            this.$message.error("暂时不能使用了，请联系管理员");
          }
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    async stopGeneratArticle() {
      clearInterval(this.updateArticleTimer);
      await Api.Chat.saveCount({
        type: "xiaohongshu_article_assistant",
        id: this.copywritingList[this.copywritingList.length - 1].articleId,
        count:
          this.copywritingList[this.copywritingList.length - 1].contentWords
            .length || 0,
      });
      this.$store.dispatch("setCount");
      this.updateArticleTimer = null;
      this.generating = false;
      document
        .getElementById("contentEle")
        .scrollTo(0, document.getElementById("contentEle").scrollHeight);
    },
    askDeleteProduct(productId, productName) {
      this.$alert(`是否确认删除产品信息“${productName}”?`, "", {
        confirmButtonText: "确定",
        showCancelButton: true,
        cancelButtonText: "手滑了！",
        callback: (action) => {
          if (action === "confirm") {
            this.deleteSavedProduct(productId);
          }
        },
      });
    },
    async deleteSavedProduct(id) {
      let res = await Api.Product.deleteProduct(id);

      if (res.error) {
        return this.$message.error("产品信息删除失败");
      }

      this.getProductList();
      return this.$message.success("产品信息删除成功");
    },
    async exportAsWord(index) {
      const content = this.copywritingList[index].contentWords;
      const title = this.productName
        ? `${this.productName}的小红书文案`
        : "小红书文案";

      let link = document.createElement("a");
      link.href = `/api/v1/chat/export?content=${btoa(
        encodeURI(content)
      )}&title=${title}`;
      link.target = "_blank";
      link.click();
      // Api.Chat.getWordExport(content,title);
    },
    async copyContent(index) {
      const copyObj = new Clipboard(".copy_btn");

      copyObj.on("success", async () => {
        this.$message.success("复制成功");
        copyObj.destroy();
        if (!this.copywritingList[index].isCopy) {
          this.copywritingList[index].isCopy = true;
        }
      });
    },
    productQuerySearch(queryString, cb) {
      cb(this.productList);
    },
    productNameSelect(item) {
      console.log(item)
      this.productList.map((a) => {
        if (a.productName === this.productName) {
          this.targetAudience = a.targetAudience;
          this.productName = a.productName;
          this.product.sellingPoint = a.sellingPoint;
          this.product.industryType = a.industryType;
          this.product.subIndustryType = a.subIndustryType;
        }
      });
    },
    close() {
      this.changeWordsDialogVisible = false;
    },
  },
  watch: {},
  created() {
    this.isMobile = window.navigator.userAgent.includes("Mobile");
    this.getProductList();
  },
  computed: {
    userId() {
      return this.$store.state.user.id;
    },
    count() {
      return this.$store.state.count;
    },
    userName() {
      return this.$store.state.user.name;
    },
  },
  destroyed() {
    if (this.updateArticleTimer) {
      clearInterval(this.updateArticleTimer);
    }
  },
  data() {
    return {
      isShow: false,
      isMobile: false,
      changeWordsDialogVisible: false,
      dialogVisible: false,
      generating: false,
      updateArticleTimer: null,
      targetAudience: [],
      productList: [],
      productName: "",
      productNameChosed: "",
      // { contentWords:'asdasdasdas11111111',editContentWords:'', star: 2, editStatus:false }
      copywritingList: [],
      loading: false,
      generatorNum: 1,
      long: "短",
      copywritingStyle: [],
      copywritingType: [],
      keyWords: "",
      product: {
        industryType: "",
        subIndustryType: "",
        sellingPoint: "",
      },
      IndustryList: [
        {
          value: "家电行业",
          label: "家电行业",
        },
        {
          value: "3C行业",
          label: "3C行业",
        },
        {
          value: "美妆行业",
          label: "美妆行业",
        },
        {
          value: "快消行业",
          label: "快消行业",
        },
        {
          value: "汽车行业",
          label: "汽车行业",
        },
        {
          value: "松下电器",
          label: "松下电器",
        },
        {
          value: "其他行业",
          label: "其他行业",
        },
      ],

      subIndustryList: {
        家电行业: [
          {
            value: "电视",
            label: "电视",
          },
          {
            value: "空调",
            label: "空调",
          },
          {
            value: "洗烘",
            label: "洗烘",
          },
          {
            value: "冰箱",
            label: "冰箱",
          },
          {
            value: "烟灶",
            label: "烟灶",
          },
          {
            value: "洗碗机",
            label: "洗碗机",
          },
          {
            value: "蒸烤箱",
            label: "蒸烤箱",
          },
          {
            value: "热水器",
            label: "热水器",
          },
          {
            value: "净水器",
            label: "净水器",
          },
          {
            value: "小家电",
            label: "小家电",
          },
        ],
        "3C行业": [
          {
            value: "手机",
            label: "手机",
          },
          {
            value: "笔记本",
            label: "笔记本",
          },
        ],
        美妆行业: [
          {
            value: "美妆",
            label: "美妆",
          },
        ],
        快消行业: [
          {
            value: "快消",
            label: "快消",
          },
        ],
        汽车行业: [
          {
            value: "汽车",
            label: "汽车",
          },
        ],
        松下电器: [
          {
            value: "松下洗碗机",
            label: "洗碗机",
          },
        ],
        其他行业: [
          {
            value: "其他",
            label: "其他",
          },
        ],


      },

      copywritingTypeList: [
        {
          value: "产品种草",
          label: "产品种草",
        },
        {
          value: "产品测评",
          label: "产品测评",
        },
        {
          value: "选购攻略",
          label: "选购攻略",
        },
      ],

      targetAudienceList: [
        {
          value: "大众用户",
          label: "大众用户",
        },
        {
          value: "年轻女性",
          label: "年轻女性",
        },
        {
          value: "年轻男性",
          label: "年轻男性",
        },
        {
          value: "母婴群体",
          label: "母婴群体",
        },
        {
          value: "家庭用户",
          label: "家庭用户",
        },
        {
          value: "学生党",
          label: "学生党",
        },
        {
          value: "上班族",
          label: "上班族",
        },
        {
          value: "中产阶级",
          label: "中产阶级",
        },
      ],

      copywritingStyleList: [
        {
          value: "生活体验",
          label: "生活体验",
        },
        {
          value: "年轻活泼",
          label: "年轻活泼",
        },
        {
          value: "专业权威",
          label: "专业权威",
        },
        {
          value: "文艺清新",
          label: "文艺清新",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.xDisplay {
  display: none;
}

.max_height {
  max-height: 132px;
}

.XHForm {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
  height: 58px;
}

.XHFormLabel {
  font-size: 16px;
  color: #333333 !important;
  font-weight: 500 !important;
  width: 100px;
  height: 58px;
  align-items: center;
  display: flex;
}

.XHFormItem {
  width: calc(100% - 100px);
  height: 58px;
  padding-top: 9px;
}

.SelfDivide {
  margin: 2vw 0 2vw 0 !important;
}

.ceMetaIndustryChat {
  background-image: url("../../assets/statics/images/background.png");
  background-repeat: no-repeat;
  background-size: cover;
  width: 1270px;
  margin: 0 auto;
  margin-top: 1rem;
  height: 700px;
  border-radius: 6px;
  box-shadow: 4px 6px 6px 0px rgba(220, 220, 220, 0.08);
  display: flex;
  flex-direction: row;
  font-size: 1vw !important;
  position: relative;

  .industryFormPanel {
    box-shadow: 4px 6px 6px 0px rgba(220, 220, 220, 0.08);
    width: 50%;

    .selector {
      display: inline-flex;
      align-items: center;
      margin-bottom: 16px;
    }

    .buttonWrapper {
      display: inline-block;
      margin-left: 12px;
    }
  }

  .industryChatPanel {
    padding: 0 26px;
    box-shadow: 4px 6px 6px 0px rgba(220, 220, 220, 0.08);
    width: 50%;

    .chatBodyPanel {
      height: 520px;
      overflow: scroll;

      -webkit-scrollbar {
        width: 0px;
        /* 对应滚动条的宽度 */
        height: 0px;
        /* 对应滚动条的高度 */
      }

      .industryChatContentPanel {
        margin-top: 0.4vw;
        background-color: #ffffff;
        box-shadow: 4px 6px 6px 0px rgba(220, 220, 220, 0.08);

        .industryHeadTools {
          display: flex;
          justify-content: flex-start;
          padding: 7px 14px;
          height: 50px;
          align-items: center;
        }

        .industryChatContent {
          font-size: 14px;
          outline: none;
          text-align: justify;
          line-height: 30px !important;
          // background: #f9f7ff;
          border: 1px solid #f9f7ff;
          box-sizing: border-box;
          padding: 5px 15px;
          border-radius: 6px;
          color: #1a1a1a !important;
          font-weight: 400;
          letter-spacing: 0;
          font-family: SourceHanSansCN-Regular;
          white-space: pre-line;
        }

        .industryChatTools {
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          padding: 0 1vw;
        }
      }
    }
  }
}

.flexPanel {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.flexEndPanel {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.shortFormItem {
  margin-bottom: 1vw !important;
}

.chattoolsItemStyle {
  margin: 0.1vw;
}

.chatSplit {
  width: 0.1vw;
  height: 0.1vw;
}

.ceMetaIndustryChatHeader {
  width: 100%;
  margin: 19px 0;
  height: 38px;
  padding: 0 24px;

  .headerWords {
    font-size: 16px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.8vw;
  }

  .chatSplitLine {
    width: 100%;
    height: 0.1vw;
    background-color: rgb(192, 192, 202);
  }
}

.generatorSelect {
  background-color: rgb(191, 190, 195);
  border-radius: 10px;
  width: 4vw;
  overflow: hidden;
  margin-left: 8px;
}

.squareSelect {
  .ant-select {
    border-radius: 0;
  }

  .ant-select-selection-search-input {
    border-radius: 0;
  }
}

.mobileLayout {
  background-image: url("../../assets/statics/home-bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: calc(100vh - 50px);

  .logo {
    text-align: center;
    font-size: 18px;

    :first-child {
      font-weight: 500;
    }

    div+div {
      margin-top: 8px;
    }
  }

  .title {
    margin-top: 44px;
    font-size: 32px;
  }

  .button {
    width: 200px;
    font-weight: bold;
    height: 48px;
    border-radius: 24px;
    margin-top: 48px;
    background: linear-gradient(150deg, #7ba0ff, #ee74ff);
    border: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/industryChat/newIndex.vue